const drawerOpen = state => state.drawerOpen
const alert = state => state.alert
const loader = state => state.loader
const currentModule = state => state.currentModule
const axiosHideLoader = state => state.axiosHideLoader
const togglePushNotification = state => state.togglePushNotification
const newVersionSnackbar = state => state.newVersionSnackbar
const routeCount = state => state.routeCount
const versionCheck = state => state.versionCheck

export default {
  drawerOpen,
  alert,
  loader,
  currentModule,
  axiosHideLoader,
  togglePushNotification,
  newVersionSnackbar,
  routeCount,
  versionCheck,
}
